module.exports = __webpack_public_path__ + "static/media/DOG FETCH 1.a38645f7.gif";